<template>
  <span
    class="my-1 d-inline-block"
    :class="{ error: Number(limit) < text.length }"
  >
    {{ text.length }} / {{ limit }}
  </span>
</template>

<script>
export default {
  props: ["limit", "text"],
};
</script>

<style lang="scss" scoped>
.error {
  color: #f00;
}
</style>
